import { useState } from 'react';
import { useCartState } from './CartContext';
import {
  Box,
  Card,
  CardMedia,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { WHITELABEL_IMAGE_PLACEHOLDER } from 'components/constants/Constants';
import EditOutlined from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { Link } from 'react-router-dom';
import { CartItem } from './types';
import { ProductType } from 'types/Products';
import { EditCartDialog } from 'components/common/Requests/EditCartDialog';

export const DrawerProductCard = ({ product }: { product: CartItem }) => {
  const { setValue, setDrawerOpen } = useCartState();
  const [editDialog, setEditDialog] = useState(false);
  const removeFromCart = (id?: string) => {
    if (id) {
      setValue(prev => ({
        ...prev,
        items: prev.items.filter(item => item.old_key !== id)
      }));
    }
  };
  return (
    <>
      <Card
        key={product.old_key}
        sx={{
          padding: 1,
          display: 'flex',
          gap: 2,
          flexShrink: 0
        }}
        variant="outlined"
      >
        <CardMedia
          component="img"
          sx={{ objectFit: 'cover', width: 100, height: 100 }}
          src={product.imageUrl ?? WHITELABEL_IMAGE_PLACEHOLDER}
        />
        <Box sx={{ flexGrow: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            <Typography
              variant="body2"
              fontWeight={'bolder'}
              sx={{ textDecoration: 'underline' }}
              component={Link}
              onClick={() => setDrawerOpen(false)}
              to={`${
                product.type === ProductType.FORMULATIONS
                  ? 'concepts'
                  : product.type.toLowerCase()
              }/permalink/${product.old_key}`}
            >
              {product.name}
            </Typography>

            <Stack direction="row">
              <IconButton
                color="primary"
                size="small"
                onClick={() => setEditDialog(true)}
              >
                <EditOutlined fontSize="small" />
              </IconButton>
              <IconButton
                color="primary"
                size="small"
                onClick={() => removeFromCart(product.old_key)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
          <Box>
            <Box
              sx={{ display: 'grid', gridTemplateColumns: '3fr 2fr', mb: 1 }}
            >
              <Typography variant="caption" sx={{ opacity: 0.5 }}>
                Number of samples:
              </Typography>
              <Typography variant="caption">
                {product.quantity} units
              </Typography>
            </Box>
            <Box
              sx={{ display: 'grid', gridTemplateColumns: '3fr 2fr', mb: 1 }}
            >
              <Typography variant="caption" sx={{ opacity: 0.5 }}>
                Needed by:
              </Typography>
              <Typography variant="caption">
                {product.neededBy &&
                  new Date(product.neededBy).toLocaleDateString()}
              </Typography>
            </Box>
            <Box
              sx={{ display: 'grid', gridTemplateColumns: '3fr 2fr', mb: 1 }}
            >
              <Typography variant="caption" sx={{ opacity: 0.5 }}>
                Estimated yearly usage:
              </Typography>
              {product.estimatedYearlyUsage && (
                <Typography variant="caption">
                  {product.estimatedYearlyUsage} kg
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Card>
      {editDialog && (
        <EditCartDialog
          open={editDialog}
          onClose={() => setEditDialog(false)}
          product={product}
        />
      )}
    </>
  );
};
